/*
 * @Author: MX
 * @Date: 2021-03-26 15:50:23
 * @Description:
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import langs from './langs'
import store from '@store'
import * as constants from '../constants'

Vue.use(VueI18n)

const lang = constants.LANG_ELEMENT_MAP[store.state.base.lang]
const i18n = new VueI18n({
  locale: lang || process.env.VUE_APP_I18N_LOCALE || 'zh-cn', // 初始未选择默认 en 英文
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'zh-cn',
  messages: { ...langs },
})
import { bus } from '@utils/common'
bus.$on('langJsonChange', (data) => {
  const lang = constants.LANG_ELEMENT_MAP[store.state.base.lang]
  i18n.locale = lang || process.env.VUE_APP_I18N_LOCALE || 'zh-cn'
})
// locale.i18n((key, value) => i18n.t(key, value)) // 兼容element
export default i18n
